<template>
  <div>
    <PageBanner :obj="obj"></PageBanner>
    <router-view></router-view>
  </div>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "海玛产品",
        en: "HAIMA PRODUCTS",
        link: "/product",
        image: "",
        list: [],
      },
    };
  },
  methods: {
    async productIndex() {
      let res = await service.productIndex();
      if (res.code == 1) {
        this.obj.cn = res.data.banner.name;
        this.obj.en = res.data.banner.eng_title;
        this.obj.image = this.$baseURL + res.data.banner.thumb;
        this.obj.list = res.data.catlist.map((item, index) => {
          return { ...item, comp: "/product/list" };
        });
      }
    },
  },
  created() {
    this.productIndex();
  },
};
</script>

<style></style>